export const CallSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="13"
      height="18"
      viewBox="0 0 13 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.47665 1.03267L3.37332 0.746C4.21499 0.477667 5.11249 0.911834 5.47332 1.76017L6.18915 3.45017C6.50082 4.186 6.32832 5.05183 5.76082 5.59017L4.18249 7.0885C4.27915 7.98517 4.58082 8.86767 5.08582 9.736C5.56564 10.5762 6.20918 11.3115 6.97832 11.8985L8.87415 11.2652C9.59332 11.026 10.3758 11.3018 10.8158 11.9493L11.8433 13.4577C12.3558 14.211 12.2642 15.2493 11.6283 15.8877L10.9467 16.5718C10.2683 17.2527 9.29915 17.5002 8.40332 17.2202C6.28749 16.5602 4.34249 14.601 2.56749 11.3427C0.789987 8.07933 0.162487 5.30933 0.685821 3.036C0.905821 2.07933 1.58665 1.31683 2.47665 1.03267Z"
        fill="white"
      />
    </svg>
  )
}